var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIfcGroupSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 2H3V30H29V2H25ZM5 28V4H27V28H5Z",
    fill: "#363545"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 15V6H7V15H15Z",
    fill: "#363545"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 15V6H17V15H25Z",
    fill: "#363545"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 26V17H7V26H15Z",
    fill: "#363545"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25 26V17H17V26H25Z",
    fill: "#363545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIfcGroupSvg);
export default __webpack_public_path__ + "static/media/IfcGroup_svg.f73ef5019e1b41232b789c23d0ef35ae.svg";
export { ForwardRef as ReactComponent };